import * as classnames from 'classnames/bind';
import {css} from 'glamor';
import _isFunction from 'lodash/isFunction';
import * as React from 'react';
import * as Keys from '@mintdata/mint-kit/impl/util/Keys';

const styles = require('@mintdata/mint-kit/impl/properties/components/pill/Pill.less');
const cx = classnames.bind(styles);

export interface IPillProps
{
    className?:string;
    activeClassName?:string;
    style?:React.CSSProperties;
    activeStyle?:React.CSSProperties;
    removeButtonClassName?:string;
    removeButtonStyle?:React.CSSProperties;
    removeButtonIconStyle?:React.CSSProperties;
    removeButtonHoverIconStyle?:React.CSSProperties;
    index?:number;
    activeIndex?:number;
    active?:boolean;
    onRemove?:(event:React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => void;
    onFocus?:(index:number) => void;
    onBlur?:(index:number) => void;
}

export class Pill extends React.Component<IPillProps, any>
{
    private _self:HTMLSpanElement = null;

    public componentWillReceiveProps(nextProps:any)
    {
        const {index, activeIndex} = nextProps;

        if( index === activeIndex )
            this._self.focus();
    }

    public render()
    {
        const {
            className,
            activeClassName,
            style,
            activeStyle,
            removeButtonClassName,
            removeButtonStyle,
            removeButtonIconStyle,
            removeButtonHoverIconStyle,
            active,
            children,
            onRemove,
            index,
            onFocus,
            onBlur,
        } = this.props;

        const isRemovable = _isFunction(onRemove);

        const pillClasses = cx('base', {isRemovable, active}, className, active ? activeClassName : null);

        const buttonStyle = css({
            ...removeButtonStyle,
            ['&:hover svg']: removeButtonHoverIconStyle
        });

        const removeButton = isRemovable ? (
            <button
                type='button'
                className={cx('pillRemove', removeButtonClassName)}
                {...buttonStyle}
                onClick={this._handleRemoveClick}
                onKeyDown={this._handleRemoveKeyDown}
                ref={(ref:HTMLSpanElement) => this._self = ref}
            >
                <svg
                    viewBox='0 0 24 24'
                    style={removeButtonIconStyle}
                >
                    <path
                        d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' />
                </svg>
            </button>
        ) : null;

        let finalStyle:React.CSSProperties = {...style};

        if( active )
            finalStyle = {...finalStyle, ...activeStyle};

        return (
            <span className={pillClasses} style={finalStyle}
                onFocus={() => onFocus && onFocus(index)}
                onBlur={() => onBlur && onBlur(index)}
            >
                {children}
                {removeButton}
            </span>
        );
    }

    private _handleRemoveKeyDown = (event:React.KeyboardEvent<HTMLButtonElement>) =>
    {
        if( event.which === Keys.BACKSPACE )
            {
                const {onRemove} = this.props;
                onRemove(event);
            }
    }
    
    private _handleRemoveClick = (event:React.MouseEvent<HTMLButtonElement>) =>
    {
        const {onRemove} = this.props;
        onRemove(event);
    };
}

